import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { catchError, Observable, of, throwError } from 'rxjs';
import { SessionService } from '../auth/session.service';
import { Router } from '@angular/router';
import { CommunicationService } from 'src/app/shared/services/communication.service';

// Remember to add the following code to AppModule:
// import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
// providers: [
//   {
//      provide: HTTP_INTERCEPTORS,
//      useClass: AuthInterceptorService,
//      multi: true
//    }
//   ]

@Injectable({
  providedIn: 'root'
})
export class AuthInterceptorService {

  constructor(private session: SessionService, private router: Router, private communicator: CommunicationService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>{
    const token: string | null = this.session.getItem('token');
    let request = req;
    
    if (req.headers.get('skip') === 'true') {
      return next.handle(req);
    }
    if (token) {
      request = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }
    return next.handle(request)
  }
}
